import Strip from 'modules/Telematics/components/TelematicsRightPanel/LiveSummary/Graph/Strip';
import {
	INIT_COMBINED_GRAPHICAL_METRICS_DATA,
	ORDERED_METRIC_GRAPH_KEYS,
} from 'modules/Telematics/components/TelematicsRightPanel/LiveSummary/constants';
import { CombinedGraphicalMetricData } from 'modules/Telematics/components/TelematicsRightPanel/LiveSummary/types';
import styles from './index.module.css';

interface Props {
	combinedGraphicalMetricData: CombinedGraphicalMetricData;
}
export default function Graph(props: Props) {
	return (
		<div className={styles.graphContainer}>
			<div className={styles.hourNames}>
				<div className={styles.hour} style={{ top: '10px' }}>
					12:00 AM
				</div>
				<div className={styles.hour} style={{ top: '130px' }}>
					6:00 AM
				</div>
				<div className={styles.hour} style={{ top: '250px' }}>
					12:00 PM
				</div>
				<div className={styles.hour} style={{ top: '370px' }}>
					6:00 PM
				</div>
			</div>
			<div className={styles.graph}>
				{ORDERED_METRIC_GRAPH_KEYS.map((key) => {
					return (
						<Strip
							key={key}
							data={
								props.combinedGraphicalMetricData[
									key as keyof typeof INIT_COMBINED_GRAPHICAL_METRICS_DATA
								]
							}
						/>
					);
				})}
			</div>
		</div>
	);
}
